import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import { formatReceived } from 'utils/formatValues';
import Moment from 'moment';
// LICENCIAS DE FUNCION
export const baseURI = '/empresas/expedientes-de-licencias/';

/**
 * GET ExpedienteExpedientesDeLicencias
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getExpedientesDeLicencias = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET ExpedienteDeLicencia
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getExpedienteDeLicencia = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST ExpedienteDeLicencia
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postExpedienteDeLicencia = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH ExpedienteDeLicencia
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchExpedienteDeLicencia = async (id, _values) => {
  try {
    const values = {
      ..._values,
      fecha_de_ultimo_movimiento: Moment(),
    };
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE ExpedienteDeLicencia
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteExpedienteDeLicencia = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Para obtener los cargos de un vehiculo
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getExpedienteDeLicenciaCaja = async (params = null) => {
  try {
    const response = await API.get('empresas/expedientes-de-licencias-caja', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
